import type { StartupTableEntry } from "content-ui/briefings/fetchers/briefingReportFetcher";

/** Maps heading titles to the data's property names as defined in Dato */
const formatFieldName = (fieldName) => {
  switch (fieldName) {
    case "location":
      return "country";
    case "total funding":
      return "totalFunding";
    case "last round size":
      return "lastRoundSize";
    case "stage":
      return "lastRoundStage";
    default:
      return fieldName;
  }
};

export function sortBy(
  fieldName: string,
  data: StartupTableEntry[],
  isAscending: boolean
) {
  const formattedFieldName = formatFieldName(fieldName);

  return data.sort((a: StartupTableEntry, b: StartupTableEntry) => {
    const first =
      typeof a[formattedFieldName] === "string"
        ? a[formattedFieldName].toLowerCase()
        : a[formattedFieldName];
    const second =
      typeof b[formattedFieldName] === "string"
        ? b[formattedFieldName].toLowerCase()
        : b[formattedFieldName];

    // Only sort rows with data (leave falsy values unsorted at bottom of the table)
    if (first === "" || first === null || first === 0) return 1;
    if (second === "" || second === null || first === 0) return -1;
    if (first === second) return 0;

    if (isAscending) {
      return first > second ? 1 : -1;
    } else {
      return first < second ? 1 : -1;
    }
  });
}

export function formatMoney(
  value: string | number
): string | [number, string] | undefined {
  const n = Number(value);
  if (n < 1e3) return String(n);
  if (n >= 1e3 && n < 1e6) return [+(n / 1e3).toFixed(0), "k"];
  if (n >= 1e6 && n < 1e9) return [+(n / 1e6).toFixed(1), "m"];
  if (n >= 1e9 && n < 1e12) return [+(n / 1e9).toFixed(1), "b"];
  if (n >= 1e12) return [+(n / 1e12).toFixed(1), "t"];
  return undefined;
}
